import { Injectable } from "@angular/core";
import { ContractsService } from "../contracts.service";
import { Web3Service } from "app/services/web3/web3.service";
import { Observable, ReplaySubject, first, from, tap } from "rxjs";
import { eContracts } from "../contract.config";

@Injectable({
    providedIn: 'root'
})

export class PancakeV2Service {

    public contract: any
    private _isConversionCompleted: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

    constructor(
        private contractsService: ContractsService,
        private web3Service: Web3Service
    ) {
        this.contract = this.contractsService.getContract(eContracts.PancakeV2);
    }

    swapExactETHForTokens(minStartAmountPerc: number, valueToConvertInFinalCurr: number, wallet: string, expireSeconds: number = 600, amountToConvert: number, fromAddress: string, toAddress: string): Observable<any> {
        /* valueToConvertInFinalCurr is the value of starting token in final token eg:
        if you want to convert KMON to BNB valueToConvertInFinalCurr is the price in BNB of KMON 0.000030329202351042 value taken by
        https://api.coingecko.com/api/v3/simple/price?ids=kryptomon,wbnb&vs_currencies=bnb,usd&precision=18 =>    result.kryptomon.bnb
        */
        let path: string[] = [toAddress, fromAddress];
        let finalAmountWei = this.web3Service.toWei(amountToConvert);
        let minStartAmount = amountToConvert / valueToConvertInFinalCurr * minStartAmountPerc;
        let minStartAmountWei = this.web3Service.toWei(minStartAmount);
        let expiry = Math.floor(Date.now() / 1000) + expireSeconds;
        let expireWei = this.web3Service.toWei(expiry);
        this._isConversionCompleted.next(false);
        return from(this.contract.methods
            .swapExactETHForTokens(minStartAmountWei, path, wallet, expireWei)
            .send({
                ...this.contractsService.additionalParameters(),
                from: wallet,
                value: finalAmountWei
            })).pipe(
                tap(res => this._isConversionCompleted.next(true))
            )
    }

    get isConversionCompleted$(): Observable<boolean> {
        return this._isConversionCompleted.asObservable();
    }

}